/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import IScene from "./scene_interface";
import Model from "./structural_elements/model";
import IModel from "./structural_elements/model_interface";

export default
class CameraAnimation {
    private _sceneAPI: IScene;
    private _sapiModelRef: Model;
    private _animation: any;

    constructor(aSceneModel: IModel) {
        this._sceneAPI = aSceneModel.getSceneAPI();
        this._sapiModelRef = null;

        this._animation = null;
    }

    private _setSAPIModel(aSAPIModel: Model) {
        this._sapiModelRef = aSAPIModel;
    }

    public getModel(): Model {
        return this._sapiModelRef;
    }

    public setAnimation(aAnimation: any) {
        this._animation = aAnimation;
    }

    public getID(): string {
        if (!this._animation) {
            return "";
        }

        return this._animation.getID();
    }

    public getUrl(): string {
        if (!this._animation) {
            return "";
        }

        return this._animation.getUrl();
    }

    public getName(): string {
        if (!this._animation) {
            return "";
        }

        return this._animation.getName();
    }
}
